<template>
    <layout-blacked-out>
        <main role="main" class="background-employer-dashboard pt-sm-3">
            <header-size-one title="Welkom op je dashboard"
                             subtitle="Hier vind je alle belangrijke informatie over jouw gegevens, budget en opleidingen"/>
            <div class="border-radius-8 text-center text-sm-left p-4 m-2 m-md-3 dashboard-box">
                <div class="container-fluid container-lg pt-3">
                    <div class="font-poppins font-weight-light font-size-18 color-blue align-content-stretch">
                        <p> Als gevolg van de nieuwe collectieve arbeidsovereenkomst (cao), zijn er vanaf {{ locked_out_date}}
                            wijzigingen in werking getreden met betrekking tot het individueel ontwikkelbudget (IOB).
                            Voorheen werd het IOB uitgevoerd door De Leerrekening, maar met het aflopen van de cao is
                            tevens ons contract door INretail beëindigd.
                        </p>
                        <p>
                            Vanaf 22 mei is het om die reden niet mogelijk om gebruik te maken van het IOB binnen onze
                            catalogus en zullen wij de maandelijkse opbouw niet verder faciliteren.
                        </p>
                        <p>Voor vragen over het gebruik van het IOB of over de maandelijkse opbouw ervan kun je contact
                            opnemen met je leidinggevende. Ondanks er geen collectieve afspraak is gemaakt, bestaat er
                            wel de mogelijkheid om individuele afspraken met werkgevers te maken, zodat je als werknemer
                            met IOB alsnog gebruik kan blijven maken van reeds opgebouwd IOB budget binnen onze
                            catalogus.

                            Bij verdere vragen kun je contact opnemen met <a href="mailto:inretail@deleerrekening.nl">inretail@deleerrekening.nl</a>
                            of kun je de <a href="https://www.deleerrekening.nl/faq/100270081/vragen-omtrent-deactivatie-inretail" target="_blank">FAQ</a> bekijken.
                        </p>

                    </div>
                </div>
            </div>

        </main>
    </layout-blacked-out>
</template>

<script>
import LayoutBlackedOut from "../../Shared/LayoutBlackedOut.vue";
import HeaderSizeOne from "../../Shared/HeaderSizeOne.vue";

export default {
    metaInfo() {
        return {
            title: Lang.get('employeedashboard::pages/dashboard/dashboard.meta.title'),
        }
    },
    data() {
        return {}
    },
    components: {
        HeaderSizeOne,
        LayoutBlackedOut,
    },
    props: {
        budget: Object,
        locked_out_date: {
            type: String,
            required: true,
        },
    },
}
</script>
